import { Middleware } from 'redux'
import { addPendingRequest, removePendingRequest } from '../../actions/core/pendingRequests.actions'
import { isApiFailureAction, isApiRequestAction, isApiSuccessAction } from '../../apiRequest'

const PENDING_REQUEST_EXCLUSIONS = [
    "/buildabilityStatus",
]

const shouldExcludeFromPending = (url: string): boolean => {
    return PENDING_REQUEST_EXCLUSIONS.some(exclusion => url.includes(exclusion))
}

const apiUiMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)
    const { dispatch } = store

    if (isApiRequestAction(action)) {
        const { url } = action.meta.options
        const { causedBy } = action.meta

        if (!shouldExcludeFromPending(url)) {
            dispatch(addPendingRequest(url, { causedBy }))
        }   
    }

    if (isApiSuccessAction(action) || isApiFailureAction(action)) {
        const { url } = action.meta.options
        const { causedBy } = action.meta
        
        if (!shouldExcludeFromPending(url)) {
            dispatch(removePendingRequest(url, { causedBy }))
        }

    }
}

export default apiUiMiddleware
